const imageGallerySliders = document?.querySelectorAll(
  ".image-gallery.with-slider"
);
imageGallerySliders?.forEach((item) => {
  var swiperObject = new Swiper(item, {
    slidesPerView: 2,
    spaceBetween: 20,
    navigation: {
      nextEl: item?.querySelector(".swiper-button-next"),
      prevEl: item?.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
        spaceBetween: 10,
      },
      920: {
        slidesPerView: 3.8,
        spaceBetween: 10,
      },
    },
    pagination: {
      el: item?.querySelector(".swiper-pagination"),
      clickable: true,
    },
  });
});
